module.exports = __webpack_public_path__ + "static/media/cockfight.4a842b83.webp";